import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { Box, Typography } from "@mui/material"
import { UseDialogBajaContext } from "Components/bajas/DialogDetailBaja/components/DialogBajaContext"
import { earningsIdDelete } from "Components/bajas/services/api"
import { useState } from "react"

export default function PerceptionDelete({ open, setOpen, refresh, perception }) {
	const { baja } = UseDialogBajaContext()
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(earningsIdDelete, { success, end })
	const handleSubmit = () => {
		setDisabled(true)
		fetch(baja.id, perception.id)
	}
	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				title: "Eliminar Percepción",
				maxWidth: "xs",
				handleSubmit,
				disabled,
			}}
		>
			<Box sx={{ display: "grid", gap: 2, mt: 2 }}>
				<Typography variant="body1" textAlign="center">
					¿Estás seguro de que deseas eliminar la percepción{" "}
					<strong>"{perception.name}"</strong> con monto{" "}
					<strong>{perception.amount}</strong>?
				</Typography>
			</Box>
		</DialogMaster>
	)
}
